import Vue from 'vue'
import Vuex from 'vuex'
import {checkPermission} from "@/api";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: '',
        user: '',
        permission: '',
    },
    mutations: {
        increment(state) {
            // 变更状态
            state.token = ''
            state.user = ''
            state.permission = ''
        },
        upUserInfo(state,data){
            state.user = data
        },
        setPermission(state,data){
            state.permission = data
        }
    },
    actions: {
        LogOut(context) {
            context.commit('increment')
        },
        upUserInfo(context,data) {
            context.commit('upUserInfo',data)
        },
        async getPermission(context,member_id) {
            const _data = await checkPermission(member_id);
            let _permissions = _data.data ? JSON.parse(_data.data) : []
            context.commit('setPermission',_permissions)
        }
    },
    modules: {
    }
})
